import {useLayoutEffect, useRef} from "react";

type UseRestoreFormDraftOptions = {
  draftRestoreValues?: Record<string, unknown> | null;
  /** Gate restore until prerequisites are ready (e.g. dispatch log types loaded). */
  when?: boolean;
  onRestore: () => void;
};

/**
 * Applies cold-start draft values before paint so compliance gates stay deferred
 * and the form registers as busy immediately after PWA reload.
 */
export function useRestoreFormDraft({
  draftRestoreValues,
  when = true,
  onRestore,
}: UseRestoreFormDraftOptions) {
  const lastPayloadRef = useRef<Record<string, unknown> | null | undefined>(undefined);
  const onRestoreRef = useRef(onRestore);
  onRestoreRef.current = onRestore;

  useLayoutEffect(() => {
    if (!draftRestoreValues || !when) {
      return;
    }
    if (lastPayloadRef.current === draftRestoreValues) {
      return;
    }
    lastPayloadRef.current = draftRestoreValues;
    onRestoreRef.current();
  }, [draftRestoreValues, when]);
}
